import { FaLightbulb } from "react-icons/fa";
import {
  FiAlertTriangle,
  FiArrowRight,
  FiBarChart2,
  FiCheck,
  FiCpu,
  FiSearch,
  FiShoppingCart,
  FiTruck,
  FiUser,
} from "react-icons/fi";

export const Icons = {
  Chart: FiBarChart2,
  User: FiUser,
  Shop: FiShoppingCart,
  Warning: FiAlertTriangle,
  Check: FiCheck,
  Search: FiSearch,
  Car: FiTruck,
  Lightbulb: FaLightbulb,
  ArrowRight: FiArrowRight,
  Cpu: FiCpu,
};
